import React from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, ButtonGroup } from 'reactstrap';
import { RiEditLine, RiDeleteBin6Line, RiMore2Line } from 'react-icons/ri';

import { AdminCountryInfoDto } from '@repo/common-types';

interface CountryQuickActionsProps {
  country: AdminCountryInfoDto;
  onEdit: () => void;
  onDelete: () => void;
}

/**
 * Quick actions dropdown for individual country rows
 */
const CountryQuickActions: React.FC<CountryQuickActionsProps> = ({ country, onEdit, onDelete }) => {
  return (
    <ButtonGroup>
      <UncontrolledDropdown>
        <DropdownToggle
          tag="button"
          type="button"
          aria-label={`More actions for country ${country.name}`}
          className="btn btn-sm d-flex align-items-center justify-content-center"
          style={{ minWidth: '32px', padding: '4px 8px' }}
        >
          <RiMore2Line size={16} />
        </DropdownToggle>
        <DropdownMenu start container="body">
          <DropdownItem onClick={onEdit}>
            <RiEditLine size={16} className="me-2" />
            Edit Country
          </DropdownItem>

          <DropdownItem divider />

          <DropdownItem onClick={onDelete} className="text-danger">
            <RiDeleteBin6Line size={16} className="me-2" />
            Delete Country
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </ButtonGroup>
  );
};

export default CountryQuickActions;
